import { useEffect, useState } from 'react';
import BrandLogo from '../ui/BrandLogo';
import useAuthStore from '../../store/authStore';
import api from '../../services/api';
import publicGroups from '../../../../backend/content/site-navigation.json';

export default function SiteFooter() {
    const token = useAuthStore(s => s.token);
    const isAdmin = useAuthStore(s => s.user?.role === 'admin');
    const [navigation, setNavigation] = useState({ token: null, groups: publicGroups });
    useEffect(() => {
        let active = true;
        api.get('/site-navigation.php').then(({ data }) => {
            if (active && Array.isArray(data.data?.groups)) setNavigation({ token, groups: data.data.groups });
        }).catch(() => {});
        return () => { active = false; };
    }, [token]);
    const groups = navigation.token === token ? navigation.groups : publicGroups;
    const publicNavigation = [...groups.filter(g => !g.admin && g.id !== 'fiches'), ...groups.filter(g => g.id === 'fiches' && !g.admin)];
    const previews = isAdmin ? groups.filter(g => g.admin) : [];
    const renderGroup = group => (
        <nav key={group.id} className={group.admin ? 'site-footer__admin' : `site-footer__group${group.id === 'fiches' ? ' site-footer__group--fiches' : ''}`} aria-label={group.title}>
            <h2 className="site-footer__heading">{group.title}</h2>
            <ul className="site-footer__links">
                {group.links.map(link => <li key={link.url}><a href={link.url}>{link.label}</a></li>)}
            </ul>
        </nav>
    );
    return (
        <footer className="site-footer">
            <link rel="stylesheet" href="/site-footer.css?v=2" />
            <div className="site-footer__inner">
                <div className="site-footer__brand"><BrandLogo width={160} /><p>Aide à la préparation aux concours et examens.</p></div>
                <div className="site-footer__grid">{publicNavigation.map(renderGroup)}</div>
                {previews.map(renderGroup)}
                <small className="site-footer__copy">© {new Date().getFullYear()} MonQuiz™ — Tous droits réservés</small>
            </div>
        </footer>
    );
}
